import { FC, useState } from 'react';
import { WrapInLayout } from '../layouts';
import { orderApi } from '../api/order.api';
import OrdersCategoryList from '../components/orders/OrdersCategoryList';
import OrdersDrilldownModal from '../components/orders/OrdersDrilldownModal';
import { DRILLDOWN_BY_WEBSITE, SUMMARY_BY_WEBSITE } from '../components/orders/categoryColumns';
import { IDateRange, presetRange } from '../components/orders/orderDatePresets';

const OrdersByWebsitePage: FC = () => {
  const [range, setRange] = useState<IDateRange>(() => presetRange('month'));

  const { data, isFetching, isError, error } = orderApi.useGetOrdersByWebsiteQuery({
    createdFrom: range.createdFrom,
    createdTill: range.createdTill,
  });

  return (
    <WrapInLayout title="Orders By Website" layout="dashboard">
      <h1 className="text-xl font-semibold mb-3">Orders By Website</h1>
      <OrdersCategoryList
        categoryTitle="from_site"
        columns={SUMMARY_BY_WEBSITE}
        unit="site(s)"
        resizeStorageKey="orders-by-website"
        rows={data}
        isFetching={isFetching}
        isError={isError}
        error={error}
        range={range}
        onRangeChange={setRange}
        renderDrilldown={(row, close) => (
          <OrdersDrilldownModal
            title={`Orders from ${row.category}`}
            columns={DRILLDOWN_BY_WEBSITE}
            createdFrom={range.createdFrom}
            createdTill={range.createdTill}
            website={row.category}
            onClose={close}
          />
        )}
      />
    </WrapInLayout>
  );
};

export default OrdersByWebsitePage;
